import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '@pages/home';
import Detail from '@pages/detail';
import SelfInfo from '@pages/self-info';
import SelfRes from '@pages/self-result';
// import Sample from '@pages/sample';
// import SampleDetail from '@pages/sample-detail';
// import Login from '@pages/login';
// import SelfCenter from '@pages/self-center';
// import FrontTech from '@pages/front-tech';
// import VideoDetail from '@pages/video-detail';
// import MyCollection from '@pages/my-collection';
// import Industry from '@pages/industry';
// import Register from '@pages/register';
// import SampleFilpper from '@pages/sample-filpper';
// import MyInfo from '@pages/my-info';

export default function() {
    return (
      <>
        <Routes>
          <Route path="/" element={<SelfInfo />} />
          <Route path="/detail" element={<Detail />} />
          <Route path="/self-info" element={<SelfInfo />} />
          <Route path="/self-result" element={<SelfRes />} />
        </Routes>
      </>
    );
}
